import { ref } from 'vue'
import { v2 } from '@/services/api.js'

// Module-level singleton: the tool list is the same for every user and rarely
// changes, so every popover instance shares one fetch instead of re-requesting
// every time it's opened.
const tools = ref([])
const loading = ref(false)
const error = ref('')
let loadPromise = null

async function fetchTools() {
  loading.value = true
  error.value = ''

  try {
    const { data } = await v2.get('/conversations/tools')
    tools.value = Array.isArray(data) ? data : []
  } catch (err) {
    error.value = err.response?.data?.message || 'Failed to load tools'
  } finally {
    loading.value = false
  }
}

// Fetches once and caches the result; cleared on failure so the next open retries.
function ensureLoaded() {
  if (tools.value.length) return Promise.resolve()
  if (loadPromise) return loadPromise

  loadPromise = fetchTools().finally(() => {
    loadPromise = null
  })

  return loadPromise
}

export default function useAssistantTools() {
  return { tools, loading, error, ensureLoaded }
}
